import { S3 } from 'aws-sdk';
import { Injectable } from '@angular/core';
import { APPCONSTANTS } from '../../app/app.constants';
import { ErrorDialogComponent } from '../components/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../components/success-dialog/success-dialog.component';
import { formatDate } from '@angular/common';
import { CustomErrorHandlerService } from './custom-error-handler.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { environment } from'src/environments/environment';
import { gzip, ungzip } from 'pako';
const { Buffer } = require('buffer');

@Injectable({
    providedIn: 'root'
  })


export class FileService {
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(
  private http: HttpClient,
  private customErrorHandlerService: CustomErrorHandlerService){}

 async uploadBackuptoS3(params: {bucket:string; key:string; file:any; assetID:any;}){
  const param = {
    Bucket: params.bucket,
    Key: `${params.key}.json`,
    Body: params.file,
    assetID: params.assetID,
    ContentType: 'json',
    Compressed: true
  };
  return this.http
  .post(
    `${Buffer.from(environment.environmentURL, "base64").toString()}/s3/v2/upload-file`,
    param,
    this.httpOptions
  )
  .pipe(catchError(this.customErrorHandlerService.handleError));
  }

  compress(data: any) {
    console.log('Compressing', data);
    const byteArray = new TextEncoder().encode(data);
    const gzippedArray = gzip(byteArray);
    const encodedZip = Buffer.from(gzippedArray).toString('base64');
    return encodedZip;
  }
}